import * as s from '~js/utils/selectors';
import * as a from '~js/utils/attributes';

export class DeferredLoading extends HTMLElement {
  constructor() {
    super();

    this.container = this;
    if (this.hasAttribute(a.attributes$L.deferredContainer)) {
      this.container =
        this.closest(this.getAttribute(a.attributes$L.deferredContainer)) || this.closest(s.selectors$18.shopifySection);
    }

    this.deferredTriggers = this.container.querySelectorAll(this.dataset.deferredTriggers);
  }

  connectedCallback() {
    if (this.deferredTriggers.length == 0) {
      this.container.addEventListener(
        'mouseenter',
        () => {
          if (this.hasAttribute(a.attributes$L.loaded)) return;
          this.loadTemplate();
        },
        { once: true }
      );

      return;
    }

    this.deferredTriggers.forEach((trigger) => {
      trigger.addEventListener(
        'mouseenter',
        () => {
          if (this.hasAttribute(a.attributes$L.loaded)) return;
          this.loadTemplate();
        },
        { once: true }
      );
    });
  }

  loadTemplate() {
    const content = document.createElement('div');
    const template = this.querySelector(s.selectors$18.template);
    if (!template || !template?.content?.firstElementChild) return;

    content.appendChild(template.content.firstElementChild.cloneNode(true));

    const deferredContent = content.querySelector(s.selectors$18.deferredContent);
    if (!deferredContent) return;

    this.append(deferredContent);
    this.setAttribute(a.attributes$L.loaded, true);

    const containsImages = deferredContent.querySelectorAll(s.selectors$18.img).length > 0;
    if (containsImages) {
      this.reloadSrcset(this);
    }
  }

  // Reload srcset for correct image render on Safari - fixes 'object-fit: cover' issues
  reloadSrcset(container) {
    if (!container) return;
    container.querySelectorAll(s.selectors$18.img).forEach((img) => {
      const reloadSrcsetException = img.parentNode.matches(s.selectors$18.reloadSrcsetException);

      if (!reloadSrcsetException) {
        const srcset = img.getAttribute(a.attributes$L.srcset);
        img.setAttribute(a.attributes$L.srcset, '');
        img.setAttribute(a.attributes$L.srcset, srcset);
      }
    });
  }
}